

// document.addEventListener('click', function(e) {
//   const loadMoreBtn = e.target.closest('#LoadMore');
//   if (!loadMoreBtn) return;

//   // Detect store language
//   const lang = document.documentElement.lang;

//   // Define text for both languages
//   const loadmoreText = lang === "ar" ? "تحميل المزيد" : "Load More";
//   const loadingText = lang === "ar" ? "تحميل..." : "Loading...";

//   e.preventDefault();
//   loadMoreBtn.textContent = loadingText;

//   const nextUrl = loadMoreBtn.dataset.nextUrl;

//   fetch(nextUrl)
//     .then(res => res.text())
//     .then(html => {
//       const parser = new DOMParser();
//       const doc = parser.parseFromString(html, 'text/html');
//       const newProducts = doc.querySelectorAll('#product-grid .product-grid-item');
//       const newButton = doc.querySelector('#LoadMore');

//       const productGrid = document.querySelector('#product-grid');
//       newProducts.forEach(product => productGrid.appendChild(product));

//       if (newButton) {
//         loadMoreBtn.dataset.nextUrl = newButton.dataset.nextUrl;
//         loadMoreBtn.textContent = loadmoreText;
//       } else {
//         loadMoreBtn.remove();
//       }
//       updateProgressBar();
//       updateViewedCount(newProducts.length);
//     })
//     .catch(() => {
//       loadMoreBtn.textContent = 'Error. Try again';
//     });
// });
//  function updateProgressBar() {
//   const progressBar = document.getElementById('ProductProgressBar');
//   const total = parseInt(document.querySelector('.viewed-count').dataset.total, 10);
//   const currentCount = document.querySelectorAll('#product-grid .product-grid-item').length;

//   const percentage = Math.min((currentCount / total) * 100, 100);
//   progressBar.style.width = percentage + '%';
  
//    if (percentage >= 100) {
//     const wrapper = document.querySelector('.product-progress');
//     if (wrapper) {
//       wrapper.style.transition = 'opacity 0.4s ease';
//       wrapper.style.opacity = '0';

//       setTimeout(() => {
//         wrapper.remove();
//       }, 400);
//     }
//   }
// }

// function updateViewedCount() {
//   const viewedCountEl = document.querySelector('.viewed-count');
//   if (!viewedCountEl) return;

//   const total = parseInt(viewedCountEl.dataset.total, 10);

//   const currentCount = document.querySelectorAll('#product-grid .product-grid-item').length;

//   // Detect store language
//   const lang = document.documentElement.lang;

//   // Define text for both languages
//   const YouveviewedText = lang === "ar" ? "لقد شاهدت" : "You've viewed";
//   const ofText = lang === "ar" ? "ل" : "of";
//   const productsText = lang === "ar" ? "منتجات" : "products";


    

//   viewedCountEl.textContent = `${YouveviewedText} ${currentCount} ${ofText} ${total} ${productsText}`;
// }



document.addEventListener('click', function(e) {
  const loadMoreBtn = e.target.closest('#LoadMore');
  if (!loadMoreBtn) return;

  // Detect store language
  const lang = document.documentElement.lang;

  // Define text for both languages
  const loadmoreText = lang === "ar" ? "تحميل المزيد" : "Load More";
  const loadingText = lang === "ar" ? "تحميل..." : "Loading...";

  e.preventDefault();
  
  // Prevent multiple clicks
  if (loadMoreBtn.disabled) return;
  loadMoreBtn.disabled = true;
  loadMoreBtn.textContent = loadingText;

  const nextUrl = loadMoreBtn.dataset.nextUrl;

  fetch(nextUrl)
    .then(res => res.text())
    .then(html => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newProducts = doc.querySelectorAll('#product-grid .product-grid-item');
      const newButton = doc.querySelector('#LoadMore');

      const productGrid = document.querySelector('#product-grid');
      
      // Get existing product handles to prevent duplicates
      const existingHandles = new Set();
      document.querySelectorAll('#product-grid .product-grid-item a').forEach(link => {
        const handle = link.href.split('/products/')[1]?.split('?')[0];
        if (handle) existingHandles.add(handle);
      });

      // Append only non-duplicate products
      let addedCount = 0;
      newProducts.forEach(product => {
        const link = product.querySelector('a');
        const handle = link?.href.split('/products/')[1]?.split('?')[0];
        
        // Only append if not already in grid
        if (handle && !existingHandles.has(handle)) {
          productGrid.appendChild(product);
          addedCount++;
        }
      });

      if (newButton) {
        loadMoreBtn.dataset.nextUrl = newButton.dataset.nextUrl;
        loadMoreBtn.textContent = loadmoreText;
        loadMoreBtn.disabled = false;
      } else {
        loadMoreBtn.remove();
      }
      
      updateProgressBar();
      updateViewedCount();
    })
    .catch(() => {
      loadMoreBtn.textContent = 'Error. Try again';
      loadMoreBtn.disabled = false;
    });
});

function updateProgressBar() {
  const progressBar = document.getElementById('ProductProgressBar');
  const viewedCountEl = document.querySelector('.viewed-count');
  if (!progressBar || !viewedCountEl) return;
  
  const total = parseInt(viewedCountEl.dataset.total, 10);
  const currentCount = document.querySelectorAll('#product-grid .product-grid-item').length;

  const percentage = Math.min((currentCount / total) * 100, 100);
  progressBar.style.width = percentage + '%';
  
  if (percentage >= 100) {
    const wrapper = document.querySelector('.product-progress');
    if (wrapper) {
      wrapper.style.transition = 'opacity 0.4s ease';
      wrapper.style.opacity = '0';

      setTimeout(() => {
        wrapper.remove();
      }, 400);
    }
  }
}

function updateViewedCount() {
  const viewedCountEl = document.querySelector('.viewed-count');
  if (!viewedCountEl) return;

  const total = parseInt(viewedCountEl.dataset.total, 10);
  const currentCount = document.querySelectorAll('#product-grid .product-grid-item').length;

  // Detect store language
  const lang = document.documentElement.lang;

  // Define text for both languages
  const YouveviewedText = lang === "ar" ? "لقد شاهدت" : "You've viewed";
  const ofText = lang === "ar" ? "ل" : "of";
  const productsText = lang === "ar" ? "منتجات" : "products";

  viewedCountEl.textContent = `${YouveviewedText} ${currentCount} ${ofText} ${total} ${productsText}`;
}

// Initialize progress bar on page load
document.addEventListener('DOMContentLoaded', () => {
  updateProgressBar();

/* read more */
  const btn = document.querySelector(".readmore-btn");
  if (!btn) return;

  const shortText = document.querySelector(".short-text");
  const fullText = document.querySelector(".full-text");

  // Detect store language
  const lang = document.documentElement.lang;

  // Define text for both languages
  const readMoreText = lang === "ar" ? "اقرأ المزيد..." : "Read More";
  const readLessText = lang === "ar" ? "اقرأ أقل" : "Read Less";


  btn.addEventListener("click", function () {
    const isExpanded = fullText.style.display === "inline";

    if (isExpanded) {
      // Collapse
      fullText.style.display = "none";
      shortText.style.display = "inline";
      btn.textContent = readMoreText;
    } else {
      // Expand
      fullText.style.display = "inline";
      shortText.style.display = "none";
      btn.textContent = readLessText;
    }
  });

}); 

  /* tags slider*/
function initCollectionTags() {
  const elem = document.querySelector('.collection-tags');
  if (!elem) {
    setTimeout(initCollectionTags, 100); // try again after 100ms
    return;
  }

  // Initialize Flickity
  const flkty = new Flickity(elem, {
    cellAlign: 'left',
    contain: true,
    wrapAround: false,
    pageDots: false,
    prevNextButtons: true,
    draggable: true,
    initialIndex: 0,
    
  });
flkty.x = 0;
flkty.positionSlider()
  // Toggle buttons if needed
  function toggleButtons() {
    const carouselWidth = elem.offsetWidth;
    const cells = elem.querySelectorAll('.flickity-cell');
    let cellsTotalWidth = 0;
    
    cells.forEach(cell => {
      cellsTotalWidth += cell.offsetWidth;
    });
    
    cellsTotalWidth += (cells.length - 1) * 10; // add gaps

    const fits = cellsTotalWidth < carouselWidth;
    const showArrows = !fits;
    
    elem.querySelectorAll('.flickity-prev-next-button').forEach(btn => {
      btn.style.display = showArrows ? 'block' : 'none';
    });
     if (fits) {
    // Center content
    const centerX = (carouselWidth - cellsTotalWidth) / 2;
    flkty.x = centerX;
  } else {
    // Left align
    flkty.x = 0;

  }
  
  flkty.positionSlider();
  }

  // // Wait for layout + run multiple times
  // setTimeout(toggleButtons, 50);
  // setTimeout(toggleButtons, 200);
  
  flkty.on('ready', toggleButtons);
  flkty.on('resize', toggleButtons);

  toggleButtons();
  // window.addEventListener('resize', toggleButtons);
}

document.addEventListener('DOMContentLoaded', initCollectionTags);



